// MARK: React
import * as React from "react";
import { observer, inject } from "mobx-react";
import "./style.scss";

// MARK: Components
import Table from "../../../../components/Table";

// MARK: Stores
import BannerStore from "../../../../stores/BannerStore";

// MARK: Resources
import strings from "../../../../resources/strings";

interface IProps {
	bannerStore: BannerStore;
}

@inject("bannerStore")
@observer
export default class BannersTable extends React.Component<IProps> {
	public componentDidMount = async () => {
		await this.props.bannerStore.getBanners();
	}

	public render() {
		const { bannerStore } = this.props;
		return (
			<>
				<Table
					title={strings.banner.title}
					rows={bannerStore.bannersTableRows}
					header={bannerStore.header}
					pageOffset={bannerStore.pageOffSet}
					loading={bannerStore.loading}
					tableIsEmptyMessage={strings.banner.table.tableIsEmpty}
					prevPage={bannerStore.previousPage}
					nextPage={bannerStore.nextPage}
					onAddClick={() => bannerStore.startBannerCreateOrEdit()}
					onEditClick={(bannerId) => bannerStore.startBannerCreateOrEdit(bannerId)}
					onDeleteClick={(bannerId, bannerName) => bannerStore.openDeleteBannerDialog(bannerId, bannerName)}
				/>
			</>
		);
	}
}
